import { t } from "@lingui/macro";
import { ArrowRight } from "@phosphor-icons/react";
import { Button } from "@reactive-resume/ui";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import { useAuthStore } from "@/client/stores/auth";

export const FinalCTASection = () => {
  const isLoggedIn = useAuthStore((s) => !!s.user);

  return (
    <section id="final-cta" className="relative overflow-hidden bg-primary py-24 sm:py-32">
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0.15),transparent_70%)]"
      />

      <motion.div
        className="container relative text-center"
        viewport={{ once: true }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
      >
        <h2 className="text-3xl font-bold tracking-tight text-primary-foreground sm:text-4xl">
          {t`Ready to land your next interview?`}
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-primary-foreground/80">
          {t`Join 42,000+ professionals who built their resume with AI. Start building now and see the difference in your job search.`}
        </p>

        <p className="mx-auto mt-4 max-w-xl text-base font-medium text-primary-foreground/90">
          {t`Plans start at $9/month. Every new subscription includes a 3-day free trial.`}
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Button
            asChild
            size="lg"
            variant="secondary"
            className="text-base font-semibold"
          >
            {isLoggedIn ? (
              <Link to="/dashboard">
                {t`Go to Dashboard`}
                <ArrowRight className="ml-2" weight="bold" />
              </Link>
            ) : (
              <Link to="/auth/register">
                {t`Build Your Resume Now`}
                <ArrowRight className="ml-2" weight="bold" />
              </Link>
            )}
          </Button>
          {!isLoggedIn && (
            <Button
              asChild
              size="lg"
              variant="link"
              className="text-primary-foreground/80 hover:text-primary-foreground"
            >
              <a href="/auth/register">{t`Start 3-day trial`}</a>
            </Button>
          )}
        </div>
      </motion.div>
    </section>
  );
};
